import { Schema } from "@markdoc/markdoc";

export const file: Schema = {
  render: "File",
  selfClosing: true,
  attributes: {
    name: {
      type: String,
      required: true,
    },
  },
};
